import { Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';

const { Option } = Select;

type Props = {
    name: string;
    title: string;
    value?: PhoneNumberInput | undefined;
    isRequired?: boolean;
    onChange: (data: { name: string; value: PhoneNumberInput | undefined }) => void;
    className?: string;
    bgGrey?: boolean;
};
const PhoneNumber: React.FC<Props> = ({ name, value, onChange, title, isRequired, className, bgGrey }) => {
    const DialCodes = useSelector((state: RootState) => state.constants.constants.countries) || [];
    const [countryCode, setCountryCode] = useState<string>(value ? value.countryCode : '');
    const [phoneNo, setPhoneNo] = useState<number | undefined>(value ? value.number : undefined);

    useEffect(() => {
        if (value) {
            setCountryCode(value.countryCode || '+65');
            setPhoneNo(value.number);
        }
    }, [value]);

    const onChangeCountryCode = (value: string | undefined) => {
        const countryCodeStr = String(value);
        setCountryCode(countryCodeStr);
        updateValues(countryCodeStr, phoneNo);
    };

    const onChangePhoneNumber = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | { name?: string; value: unknown }>,
    ) => {
        const reg = /^\d+$/;
        if (!event.target.value || event.target.value === '') {
            setPhoneNo(undefined);
            updateValues(countryCode, undefined);
            return;
        }
        if (reg.test(String(event.target.value))) {
            setPhoneNo(parseInt(String(event.target.value)));
            updateValues(countryCode, parseInt(String(event.target.value)));
        }
    };

    const updateValues = (countryCode: string, number: number | undefined) => {
        if (countryCode && number !== undefined) {
            onChange({
                name,
                value: {
                    countryCode,
                    number: number,
                },
            });
        } else {
            onChange({
                name,
                value: undefined,
            });
        }
    };

    return (
        <div className="w-auto pt-1" id="phoneNoInput">
            <label>
                {title}
                <span className="text-red-500">{isRequired ? '*' : ''}</span>
            </label>
            <Input.Group compact className={`phone_number pt-1 ${className || ''}`}>
                <div className="w-full md:w-2/5" style={{ maxWidth: '100vw' }}>
                    <Select
                        showSearch
                        onChange={onChangeCountryCode}
                        optionFilterProp="children"
                        value={countryCode}
                        className={`w-full text-xs ${bgGrey ? 'bg-[#E1EBF8] border-[#EFEFEF]' : ''}`}
                    >
                        {DialCodes.map((d, index) => (
                            <Option
                                key={`${d.dialCode}_${index}`}
                                value={d.dialCode}
                            >{`${d.name} (${d.dialCode})`}</Option>
                        ))}
                    </Select>
                </div>
                <div className="w-full md:w-3/5 mt-4 md:mt-0">
                    <Input
                        className={`${bgGrey ? 'bg-[#E1EBF8] border-[#EFEFEF]' : ''}`}
                        value={phoneNo}
                        onChange={onChangePhoneNumber}
                        placeholder={title}
                        type="number"
                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                    />
                </div>
            </Input.Group>
        </div>
    );
};

export default PhoneNumber;

export interface PhoneNumberInput {
    countryCode: string;
    number: number | undefined;
}
